import { render, staticRenderFns } from "./RtcBigIcon.vue?vue&type=template&id=601254a4"
import script from "./RtcBigIcon.vue?vue&type=script&lang=js"
export * from "./RtcBigIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports